import React from 'react';
import PropTypes from 'prop-types';
import Card from 'common/components/card';
import CardCallouts from 'common/components/card-callouts';
import CardContent from 'common/components/card-content';
import CardHeader from 'common/components/card-header';
import TrendsChart from 'common/components/trends-chart';
import {getGroupsForYearOverYearTrends} from 'common/utils/chart-util';
import {isNumberValid} from 'common/validators/number-validator';
import {t} from 'common/utils/translation-util';
import './index.scss';

/**
 * YearOverYearTrendsCard is a wrapper around the TrendsChart
 * component, giving it styling, a header, callouts.
 */
export default class YearOverYearTrendsCard extends React.Component {
  static propTypes = {
    connectDragSource: PropTypes.func,
    disableConfig: PropTypes.bool.isRequired,
    report: PropTypes.object.isRequired,
  };

  static defaultProps = {
    disableConfig: false,
    report: {},
  };

  shouldShowError(groups) {
    return !groups
      // Pull all series out of groups:
      .map((group) => group.series)
      // Flatten array of series:
      .reduce((previous, current) => previous.concat(current), [])
      // Pull all data out of series:
      .map((series) => series.data)
      // Flatten array of data:
      .reduce((previous, current) => previous.concat(current), [])
      // Is there a valid number in the data?
      .some((datum) => isNumberValid(datum.value));
  }

  render() {
    const groups = getGroupsForYearOverYearTrends(this.props.report);
    const showError = this.shouldShowError(groups);
    return (
      <Card className={'YearOverYearTrendsCard'} loading={false}>
        {(this.props.connectDragSource || ((x) => x))(
          <div>
            <CardHeader
              dataManagerUrl={this.props.report.meta.dataManagerUrl}
              disableConfig={this.props.disableConfig}
              priorityWarnings={this.props.report.priorityWarnings}
              reportId={this.props.report.id}
              subtitle={this.props.report.meta.subtitle}
              title={this.props.report.name || ''}
              warnings={this.props.report.warnings}
            />
          </div>,
        )}
        <CardContent
          errorMessage={t('No data to display.')}
          showError={showError}>
          <div>
            <TrendsChart
              groups={groups}
              gutters={{
                bottom: 18,
                left: 30,
                right: 0,
                top: 18,
              }}
            />
          </div>
          <CardCallouts meta={this.props.report.meta} />
        </CardContent>
      </Card>
    );
  }
}
